module.exports = __webpack_public_path__ + "static/img/footer1.c2d119b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/works/footer1.png
// module id = rNsY
// module chunks = 1